// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ED-z","hovered":"FD-z","hoverImage":"GD-z","mainImage":"HD-z","imageNoBackground":"ID-z","fullSizeImage":"JD-z"};